module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/PinusPumila/Nagano_PinusPumila_MRI_RCP85_End.png";